import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const validClientCodes = [
  "CPXINT",
  "CPJIO",
  "CPBONV",
  "SUNPH",
  "CPCIP",
  "SANOF",
  "CPUNITY",
  "GGLE",
  "SHUB",
];

export default function ClientCodePage() {
  const [clientCode, setClientCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleVerify = () => {
    const trimmedCode = clientCode.trim();

    if (!trimmedCode) {
      setError("Please enter a client code");
      return;
    }

    if (!validClientCodes.includes(trimmedCode.toUpperCase())) {
      setError("Please enter a valid client code");
      return;
    }

    setError("");
    navigate("/allergy-dashboard", { state: { clientCode: trimmedCode } });
  };

  return (
    <div className="relative min-h-screen bg-black px-6 py-10 overflow-hidden tab-screen">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[90%] sm:w-[70%] h-72 blur-[120px] bg-gradient-to-b from-[#A7D4FF] via-[#A7D4FF] to-[#4A6394] rounded-full" />

      <div className="relative z-10 flex min-h-screen flex-col">
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full md:w-1/3 flex flex-col gap-2">
            <p className="text-white text-xs sm:text-sm tracking-widest">
              ENTER CLIENT CODE
            </p>

            <input
              type="text"
              value={clientCode}
              onChange={(e) => setClientCode(e.target.value)}
              placeholder="Enter Client Code"
              className={`w-full py-3 px-5 rounded-xl text-sm outline-none border ${
                error ? "border-red-500" : "border-[#A6FF96]"
              }`}
            />

            {error && (
              <p className="text-red-500 text-xs sm:text-sm">{error}</p>
            )}
          </div>
        </div>

        <div className="pb-6 flex flex-col items-center gap-4">
          <button
            onClick={handleVerify}
            className="w-full md:w-1/3 py-3 rounded-full bg-white text-base sm:text-lg font-medium"
          >
            <span className="bg-gradient-to-r from-[#455C8E] via-[#455C8E] to-[#A7D4FF] bg-clip-text text-transparent">
              Verify Code
            </span>
          </button>

          <button
            onClick={() => setClientCode("")}
            className="text-white text-xs sm:text-sm opacity-80 hover:opacity-100"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
